function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { mapDeviceInfoToConvivaDeviceModel, mapDeviceInfoTypeToConvivaDeviceType, mapDeviceTypeToConvivaDeviceCategory } from '../metadata-helper';
import { getDuration } from '../../shared/asset-info';
import { CoreVideoInternal } from '../../../../core-video-internal';
import { isIon } from '../../../../utils/device-type';
export var ConvivaMetaAdapter = /*#__PURE__*/ function() {
    "use strict";
    function ConvivaMetaAdapter(tagsProvider) {
        _class_call_check(this, ConvivaMetaAdapter);
        _define_property(this, "tagsProvider", void 0);
        this.tagsProvider = tagsProvider;
    }
    _create_class(ConvivaMetaAdapter, [
        {
            key: "adaptContentTags",
            value: function adaptContentTags(sessionItem, playoutData, convivaAddonInfo, session) {
                return _object_spread({}, this.getVideoPredefinedTags(sessionItem, convivaAddonInfo, playoutData), this.getContentPredefinedTags(sessionItem, playoutData), this.getFailedCdns(playoutData), this.getContentCustomTags(sessionItem, convivaAddonInfo, playoutData, session));
            }
        },
        {
            key: "adaptAdTags",
            value: function adaptAdTags(sessionItem, playoutData, convivaAddonInfo, availableAdBreaks, ad, logger) {
                return _object_spread({}, this.getAdPredefinedTags(playoutData, ad, sessionItem, convivaAddonInfo), this.getAdDefinedTags(ad, availableAdBreaks, logger), this.getAdCustomTags(sessionItem, playoutData, convivaAddonInfo, ad, logger, availableAdBreaks));
            }
        },
        {
            key: "adaptDeviceMetadata",
            value: function adaptDeviceMetadata(convivaAddonInfo, convivaAddonConfig) {
                var deviceInformation = convivaAddonInfo.deviceInformation, deviceType = convivaAddonInfo.deviceType;
                var _obj;
                var deviceMetadata = (_obj = {}, _define_property(_obj, Conviva.Constants.DeviceMetadata.BRAND, deviceInformation.deviceBrand), _define_property(_obj, Conviva.Constants.DeviceMetadata.MANUFACTURER, deviceInformation.deviceManufacturer), _define_property(_obj, Conviva.Constants.DeviceMetadata.OS_NAME, deviceInformation.operatingSystemName), _define_property(_obj, Conviva.Constants.DeviceMetadata.OS_VERSION, "".concat(isIon() ? 'ION/' : '').concat(deviceInformation.operatingSystemVersion)), _define_property(_obj, Conviva.Constants.DeviceMetadata.VERSION, deviceInformation.deviceVersion), _obj);
                var convivaDeviceModel = mapDeviceInfoToConvivaDeviceModel(deviceInformation, convivaAddonConfig);
                if (convivaDeviceModel) {
                    deviceMetadata[Conviva.Constants.DeviceMetadata.MODEL] = convivaDeviceModel;
                }
                var convivaDeviceType = mapDeviceInfoTypeToConvivaDeviceType(deviceInformation.deviceType);
                if (convivaDeviceType) {
                    deviceMetadata[Conviva.Constants.DeviceMetadata.TYPE] = convivaDeviceType;
                }
                var convivaDeviceCategory = mapDeviceTypeToConvivaDeviceCategory(deviceType, deviceInformation.deviceModel);
                if (convivaDeviceCategory) {
                    deviceMetadata[Conviva.Constants.DeviceMetadata.CATEGORY] = convivaDeviceCategory;
                }
                return deviceMetadata;
            }
        },
        {
            key: "adaptPlayerInfo",
            value: function adaptPlayerInfo(convivaAddonInfo) {
                var frameworkVersion = convivaAddonInfo.coreVideoSdkVersion;
                if (convivaAddonInfo.deviceType === DeviceType.Android) {
                    var containerCoreSdkVersion = convivaAddonInfo.deviceInformation.containerCoreSdkVersion ? "_".concat(convivaAddonInfo.deviceInformation.containerCoreSdkVersion) : '';
                    frameworkVersion += "_".concat(convivaAddonInfo.deviceInformation.containerVersion).concat(containerCoreSdkVersion);
                }
                if (CoreVideoInternal.playerCapabilities.hasMultiplePlayerVersions) {
                    frameworkVersion += " ".concat(CoreVideoInternal.playerType, "-").concat(CoreVideoInternal.playerVersion);
                }
                var _obj;
                return _obj = {}, _define_property(_obj, Conviva.Constants.FRAMEWORK_NAME, 'HTML5'), _define_property(_obj, Conviva.Constants.FRAMEWORK_VERSION, frameworkVersion), _obj;
            }
        },
        {
            key: "adaptInitialReport",
            value: function adaptInitialReport(sessionItem, convivaAddonInfo, session) {
                return _object_spread({}, this.getVideoPredefinedTags(sessionItem, convivaAddonInfo), this.getContentCustomTags(sessionItem, convivaAddonInfo, {}, session));
            }
        },
        {
            key: "getDuration",
            value: function getDuration1(seekableRange) {
                return getDuration(seekableRange);
            }
        },
        {
            key: "getFailedCdns",
            value: function getFailedCdns(playoutData) {
                var _playoutData_failedCdns;
                if (!(playoutData === null || playoutData === void 0 ? void 0 : (_playoutData_failedCdns = playoutData.failedCdns) === null || _playoutData_failedCdns === void 0 ? void 0 : _playoutData_failedCdns.length)) {
                    return {};
                }
                return {
                    failedcdns: playoutData === null || playoutData === void 0 ? void 0 : playoutData.failedCdns.join('|')
                };
            }
        },
        {
            key: "getVideoPredefinedTags",
            value: function getVideoPredefinedTags(sessionItem, convivaAddonInfo, playoutData) {
                this.tagsProvider.updateContentData({
                    convivaAddonInfo: convivaAddonInfo,
                    sessionItem: sessionItem,
                    playoutData: playoutData
                });
                var _obj;
                return _obj = {}, _define_property(_obj, Conviva.Constants.ASSET_NAME, this.tagsProvider.getAssetName()), _define_property(_obj, Conviva.Constants.STREAM_URL, this.tagsProvider.getStreamUrl()), _define_property(_obj, Conviva.Constants.IS_LIVE, this.tagsProvider.getIsLive()), _define_property(_obj, Conviva.Constants.PLAYER_NAME, this.tagsProvider.getPlayerName()), _define_property(_obj, Conviva.Constants.VIEWER_ID, this.tagsProvider.getViewerId()), _define_property(_obj, Conviva.Constants.DEFAULT_RESOURCE, (playoutData === null || playoutData === void 0 ? void 0 : playoutData.cdns[0].name) || ''), _define_property(_obj, Conviva.Constants.APPLICATION_VERSION, convivaAddonInfo.applicationVersion), _obj;
            }
        }
    ]);
    return ConvivaMetaAdapter;
}();

//# sourceMappingURL=conviva-meta-adapter.js.map